
// Don't ask me why, but doing :src with a ~ in the path does not resolve at all...

export default {
	props: {
		type: {
			required: false,
			type: String,
			default: "",
		},
	},
};
